import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton';
import IconClose from '@mui/icons-material/Close';
import App from './App';
import { ConfProvider } from './context/ConfContext';
import theme from './theme';
import './App.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={null}
            action={(snackbarId) => (
              <IconButton onClick={() => closeSnackbar(snackbarId)}>
                <IconClose sx={{ color: 'white' }} />
              </IconButton>
            )}
          >
            <App />
          </SnackbarProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ConfProvider>
  </React.StrictMode>
);
